const About = () => {
  return (
    <div>
      <h1> welcome in food junction</h1>
    </div>
  );
};
export default About;
